import { CategoryFilterMode, LabelFilterMode, ArticleTypeFilterMode } from './index';
var ContentVisibilitySettingsBuilder = /** @class */ (function () {
    function ContentVisibilitySettingsBuilder() {
        this.settings = {
            articleTypes: [],
            categoryIds: [],
            hasAllOfLabelIds: [],
            hasAnyOfLabelIds: [],
            hasNoneOfLabelIds: [],
            categoryFilterMode: CategoryFilterMode.ALL,
            labelFilterMode: LabelFilterMode.ALL,
            articleTypeFilterMode: ArticleTypeFilterMode.ALL
        };
    }
    ContentVisibilitySettingsBuilder.prototype.withArticleTypes = function (types) {
        this.settings.articleTypes = types;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withCategoryIds = function (ids) {
        this.settings.categoryIds = ids;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withHasAllOfLabelIds = function (ids) {
        this.settings.hasAllOfLabelIds = ids;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withHasAnyOfLabelIds = function (ids) {
        this.settings.hasAnyOfLabelIds = ids;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withHasNoneOfLabelIds = function (ids) {
        this.settings.hasNoneOfLabelIds = ids;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withCategoryFilterMode = function (mode) {
        this.settings.categoryFilterMode = mode;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withLabelFilterMode = function (mode) {
        this.settings.labelFilterMode = mode;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.withArticleTypeFilterMode = function (mode) {
        this.settings.articleTypeFilterMode = mode;
        return this;
    };
    ContentVisibilitySettingsBuilder.prototype.build = function () {
        return this.settings;
    };
    return ContentVisibilitySettingsBuilder;
}());
export { ContentVisibilitySettingsBuilder };
//# sourceMappingURL=content-visibility-settings.builder.js.map